import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=535a4ace&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=535a4ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535a4ace",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('535a4ace')) {
      api.createRecord('535a4ace', component.options)
    } else {
      api.reload('535a4ace', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=535a4ace&scoped=true&", function () {
      api.rerender('535a4ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28qZvRlhJ7vuJ/JS/teamMember.vue"
export default component.exports